import React from 'react';
import { App } from '@meronex/app';

import InfiniteScroll from 'react-infinite-scroller';
import IconButton from '@material-ui/core/IconButton';
import ReadMoreReact from 'read-more-react';

import LinkLayout from '../LinkLayout';
import TextToSpeech from './TextToSpeech';
const loadingBook = require('./loadingBook.gif');
const loadingBookSmall = require('./loadingBookSmall.gif');

function Poemist(props) {
  const [poemsArray, setPoemsArray] = React.useState();
  const [activeTheme, setActiveTheme] = React.useState();

  const bgColor =
    activeTheme === 'dark' ? 'rgb(0 0 0 / 80%)' : 'rgb(255 255 255 / 85%)';
  const fetchPoems = () => {
    return new Promise((resolve, reject) => {
      window
        .fetch('https://www.poemist.com/api/v1/randompoems')
        .then((res) => {
          console.log(res);
          res.json().then((p) => resolve(p));
        })
        .catch((e) => reject(e));
    });
  };

  const loadMore = async () => {
    try {
      const morePoems = await fetchPoems();
      if (Array.isArray(morePoems) && morePoems.length > 0) {
        setPoemsArray([...poemsArray, ...morePoems]);
      }
    } catch (e) {
      console.log(e);
    }
  };
  const init = async () => {
    setPoemsArray(null);
    window.lastScrollTop = 0;
    try {
      const poems = await fetchPoems();
      if (Array.isArray(poems) && poems.length > 0) {
        setPoemsArray(poems);
      }
    } catch (e) {
      console.log(e);
    }
  };

  React.useEffect(() => {
    init();
  }, []);

  const renderPoems = () => {
    const poems = [];
    poemsArray.forEach((p, index) => {
      if (
        p.title &&
        p.content &&
        p.content.length > 10 &&
        p.poet &&
        p.poet.name
      ) {
        poems.push(
          <div
            style={{
              position: 'relative',
              lineHeight: '1.5',
              overflow: 'auto',
              boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
            }}>
            <div
              style={{
                backgroundImage: `url('https://source.unsplash.com/random/${index}')`,
                backgroundSize: 'cover',
                overflow: 'hidden',
                minHeight: '75vh',
              }}>
              <div
                style={{
                  backgroundColor: bgColor,
                  margin: '70px 15px',
                  // height: '78vh',
                  borderRadius: '10px',
                }}>
                <div style={{ padding: '10px' }}>
                  <div
                    style={{
                      fontSize: '34px',
                      fontWeight: 'bold',
                      paddingBottom: '15px',
                      maxWidth: '280px',
                    }}>
                    <div>{p.title} </div>
                    <div
                      style={{
                        fontSize: '14px',
                      }}>
                      by {p.poet.name}
                    </div>
                  </div>
                  <div
                    style={{
                      marginTop: '10px',
                      marginBottom: '10px',
                      fontSize: '20px',
                    }}>
                    <ReadMoreReact
                      min={100}
                      ideal={400}
                      max={600}
                      text={p.content}
                      readMoreText={'read more...'}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                position: 'absolute',
                bottom: '20px',
                right: '14px',
                color: 'white',
                zIndex: 9999,
              }}>
              <IconButton
                style={{
                  backgroundColor: bgColor,
                  height: '40px',
                  width: '40px',
                }}>
                <TextToSpeech
                  iconSize={20}
                  languageCode={'en-GB'}
                  voiceName={'en-GB-Wavenet-D'}
                  text={p.content}></TextToSpeech>
              </IconButton>
            </div>
          </div>
        );
      }
    });
    return poems;
  };

  if (!poemsArray) {
    return (
      <div
        style={{
          height: '100vh',
          backgroundColor: '#333339',
        }}>
        <div
          style={{
            backgroundImage: `url("${loadingBook}")`,
            position: 'relative',
            top: '25%',
            height: '300px',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            textAlign: 'center',
          }}>
          <div style={{ position: 'relative', top: '65%', color: 'white' }}>
            Loading poems...
          </div>
          <div
            style={{
              marginTop: '15px',
              color: 'gray',
              fontSize: '12px',
              position: 'fixed',
              bottom: '20px',
              margin: '0 auto',
              display: 'inline-block',
            }}>
            v.{App.metadata.build}
          </div>
        </div>
      </div>
    );
  }

  return (
    <LinkLayout
      title={'Poetry feed'}
      subtitle={'An infinite feed of poems'}
      showToggleTheme={true}
      overflow={true}
      onThemeChange={(theme) => {
        setActiveTheme(theme);
      }}
      shareUrl={'https://links.meronex.com/share/poems/index.html'}>
      <InfiniteScroll
        threshold={400}
        pageStart={0}
        loadMore={() => {
          console.log('load more');
          loadMore();
        }}
        hasMore={true}
        loader={
          <div className="loader" key={0}>
            <div
              style={{
                textAlign: 'center',
              }}>
              <img
                src={loadingBookSmall}
                style={{
                  marginTop: '5px',
                  borderRadius: '100%',
                  width: '45px',
                }}
              />
            </div>
          </div>
        }>
        {renderPoems()}
      </InfiniteScroll>
    </LinkLayout>
  );
}
Poemist.propTypes = {};

Poemist.defaultProps = {};
export default Poemist;
